// import { useState, useEffect } from "react";
import { useMemo, useState, useEffect } from "react";
import { Modal, Frame, TitleBar, Button } from "@react95/core";

import { Checkbox, Dropdown, Fieldset, Input, Tab, Tabs } from "@react95/core";

import { Regedit, Regedit205, Regedit206, FilePick, Mailnews8, Mcm3200 } from "@react95/icons";

import { useApp } from "../../context/AppContext";
import { useSecret } from "../../context/SecretContext";

import { WINDOW_NAMES } from "../../config/const";
import { getModalSizeProps } from "../../config/window";

export const NetworkStatusDef = {
  id: WINDOW_NAMES.NetworkStatus,
  title: "Network Status",
  icon: <Mcm3200 variant="32x32_4" style={{ width: "16px", height: "16px" }} />,
  hasButton: false,
};

export default function NetworkStatus() {
  const { closeModal, status } = useApp();
  const { hasUntickedDoNotUntick, fetchSecretState, untickedDoNotUntick } = useSecret();
  const icon = useMemo(() => NetworkStatusDef.icon, []);
  const sizeProps = useMemo(() => getModalSizeProps("485px", "350px", "bottom-right"), []);
  const [doNotUntick, setDoNotUntick] = useState(true);
  const [confirmStage, setConfirmStage] = useState(0);

  // fetch secret state when modal opens
  useEffect(() => {
    fetchSecretState();
  }, [fetchSecretState]);

  // ensure checkbox is unchecked and stays unchecked once quest is completed
  useEffect(() => {
    if (hasUntickedDoNotUntick) {
      setDoNotUntick(false);
    }
  }, [hasUntickedDoNotUntick]);

  return (
    <Modal
      key={NetworkStatusDef.id}
      id={NetworkStatusDef.id}
      icon={icon}
      title={NetworkStatusDef.title}
      titleBarOptions={[
        <TitleBar.Close key="close" onClick={() => closeModal(NetworkStatusDef.id)} />,
      ]}
      defaultClosed={true}
      hasWindowButton={false}
      dragOptions={sizeProps.dragOptions}
      height={sizeProps.height}
      width={sizeProps.width}
    >
      <div style={{ padding: "4px" }}>
        <Tabs defaultActiveTab="Network">
          <Tab title="Network">
            <Fieldset legend="Socket Status" style={{ marginBottom: "1em", padding: "8px" }}>
              <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                <Checkbox readOnly checked style={{ width: "100%" }}>
                  This computer is connected to at least one tube.
                </Checkbox>
                <Checkbox readOnly checked={status === "ready"} style={{ width: "100%" }}>
                  The server seems to be alive and well-fed.
                </Checkbox>
                <Checkbox readOnly checked style={{ width: "100%" }}>
                  You are visiting a website.
                </Checkbox>
                <Checkbox readOnly checked style={{ width: "100%" }}>
                  Your location is somewhere on the planet Earth.
                </Checkbox>
                <Checkbox readOnly checked style={{ width: "100%" }}>
                  <>
                    You smell nice <i>(and look great, too)</i>.
                  </>
                </Checkbox>
                {/* `doNotUntick` controlled with a 3-click confirmation before actual untick */}
                <Checkbox
                  checked={doNotUntick}
                  disabled={hasUntickedDoNotUntick || !doNotUntick}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    const attemptedChecked = e.currentTarget.checked;

                    // user re-checking the box -> reset confirmation
                    if (attemptedChecked) {
                      setDoNotUntick(true);
                      setConfirmStage(0);
                      return;
                    }

                    // attempted to uncheck -> step through confirmation stages
                    if (confirmStage === 0) {
                      setConfirmStage(1);
                      return;
                    } else if (confirmStage === 1) {
                      setConfirmStage(2);
                      return;
                    } else {
                      // final confirmation -> actually uncheck and notify server
                      setDoNotUntick(false);
                      setConfirmStage(0);
                      untickedDoNotUntick();
                    }
                  }}
                  style={{ width: "100%" }}
                >
                  {hasUntickedDoNotUntick
                    ? "Trust, but verify. (disabled)"
                    : doNotUntick
                      ? confirmStage === 1
                        ? "are you really sure?"
                        : confirmStage === 2
                          ? "fo sure, i dunno what this will do?"
                          : "Trust, but verify."
                      : "Trust, but verify. (disabled)"}
                </Checkbox>
              </div>
            </Fieldset>
          </Tab>

          <Tab title="Compatibility">
            <p style={{ marginTop: "40px", marginBottom: "40px" }}>
              You are securely {status} to this website via a series of interconnected tubes.
            </p>
          </Tab>
        </Tabs>
      </div>
    </Modal>
  );
}
